import headerCarousel from 'modules/headerCarousel';

export default {
	init() {
		headerCarousel.init($('.js-header-carousel'));
	},
};
